import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import { ProgramRef, Callout, LocalArrangement, Hero, TextLed, SideBySide, Caution, PracticeScenario, AssetPlaceholder } from '@jw-av/content/components'
import { SlideDeck } from './SlideDeck'
import { ScrollViewer } from './ScrollViewer'
import InteractiveKnowledgeCheck from './InteractiveKnowledgeCheck'

export type ModuleViewMode = 'deck' | 'scroll'

const baseComponents = {
  // Slide archetypes
  Hero,
  TextLed,
  SideBySide,
  Caution,
  KnowledgeCheck: InteractiveKnowledgeCheck,
  PracticeScenario,

  // Citation components
  ProgramRef,

  // Content components
  Callout,
  LocalArrangement,
  AssetPlaceholder,

  // Standard HTML elements can be customized here
  h1: (props: any) => <h1 {...props} className="slide-h1" />,
  h2: (props: any) => <h2 {...props} className="slide-h2" />,
  h3: (props: any) => <h3 {...props} className="slide-h3" />,
  p: (props: any) => <p {...props} className="slide-p" />,
  ul: (props: any) => <ul {...props} className="slide-ul" />,
  ol: (props: any) => <ol {...props} className="slide-ol" />,
  li: (props: any) => <li {...props} className="slide-li" />,
  blockquote: (props: any) => <blockquote {...props} className="slide-blockquote" />,
  table: (props: any) => <table {...props} className="slide-table" />,
}

interface ModuleMdxProviderProps {
  children: React.ReactNode
  viewMode?: ModuleViewMode
}

export function ModuleMdxProvider({ children, viewMode = 'deck' }: ModuleMdxProviderProps) {
  const components = {
    ...baseComponents,
    wrapper: viewMode === 'scroll' ? ScrollViewer : SlideDeck,
  }
  return (
    <MDXProvider components={components}>
      {children}
    </MDXProvider>
  )
}
